"use strict";
const { get } = require("jquery");

// Class definition
var ClientPlansDatatable = function() {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('client_id');

  // Private functions
  var _init = function() {
    var datatable = $('#kt_datatable_client_plans').KTDatatable({
        // datasource definition
        data: {
          type: 'remote',
          method: 'GET',
          source: {
            read: {
              url: '/admin/clientes/'+id+'/activaciones.json',
              method: 'GET',
              map: function(data) {
                $("#kt_subheader_total").html(data.meta.total + " Total")
                setTimeout(() => {
                  $('div#kt_datatable_client_plans .tp').tooltip('enable');
                }, 2000);
                return data.data
              }
            },
          },
          pageSize: 20,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        // layout definition
        layout: {
            scroll: false, // enable/disable datatable scroll both horizontal and vertical when needed.
            footer: false, // display/hide footer
        },
        // column sorting
        sortable: true,
        pagination: true,
        translate: {
          records: {
            processing: 'Cargando...',
            noRecords: 'No hay registros disponibles'
          },
          toolbar: {
            pagination: {
              items: {
                default: {
                  first: 'Primero',
                  prev: 'Anterior',
                  next: 'Siguiente',
                  last: 'Último',
                  more: 'Más páginas',
                  input: 'Página number',
                  select: 'Selecciona el tamaño de la página'
                },
                info: 'Mostrando {{start}} - {{end}} de {{total}} activaciones'
              }
            }
          }
        },
        // columns definition
        columns: [{
            field: 'category',
            title: 'Categoría',
            width: 200,
            template: function(data) {
              var output = '<div class="font-weight-bolder mb-0">' + data.category + '</div>';
              return output;
            },
        },{
            field: 'title',
            title: 'Plan',
            width: 200,
            template: function(data) {
              var output = '<div class="font-weight-bolder mb-0">' + data.title + '</div>';
              return output;
            },
        }, {
            field: 'init_date',
            title: 'Inicio',
            width: 120,
            template: function(data) {
              var output = '<div class="font-weight-bolder mb-0">' + data.init_date + '</div>';
              return output;
          },
        }, {
          field: 'end_date',
          title: 'Término',
          width: 120,
          template: function(data) {
            var output = '<div class="font-weight-bolder mb-0">' + data.end_date + '</div>';
            return data.name == "unlimited" ? '' : output;
          },
        }, {
            field: 'Status',
            title: 'Estado',
            width: 100,
            // callback function support for column rendering
            template: function(row) {
              if(row.is_active) {
                var output = '<span data-toggle="tooltip" data-theme="dark" title="Editar Estado" class="label label-lg font-weight-bold label-inline label-open">Activo</span>';
              } else {
                var output = '<span data-toggle="tooltip" data-theme="dark" title="Editar Estado" class="label label-lg font-weight-bold label-inline label-closed">Inactivo</span>';
              }
              return output;
            },
        }, {
            field: 'Actions',
            title: 'Acciones',
            sortable: false,
            width: 130,
            overflow: 'visible',
            autoHide: false,
            template: function(row) {
              const editLink = `<a href="/admin/clientes/${id}/activaciones/${row.id}/edit" class="icon mr-5 tp" data-toggle="tooltip" data-theme="dark" title="Editar"><i class="far fa-edit"></i></a>`;
              const deleteButton = `<button type="button" class="icon delete-button tp" data-toggle="tooltip" data-theme="dark" title="Eliminar" data-id="${row.id}" data-toggle="modal" data-target="#delete_client_plan_modal"><i class="fas fa-trash-alt"></i></button>`;
    
              const actionButtons = `
                ${editLink}
                ${!row.is_active ? deleteButton : ''} 
              `;
    
              const output = `
                <div class="d-flex align-items-center container-actions-table">
                  ${actionButtons}
                </div>
              `;
              return output;
            }
        }]
    });
  };

  return {
    // public functions
    init: function() {
      _init();
    },
  };
}();

jQuery(document).ready(function() {
  if($("#kt_datatable_client_plans").length > 0){
      ClientPlansDatatable.init();
  }

  /*************
   * ELIMINAR ACTIVACIONES
   *
   * - Logica de activacion de modal,
   * - Asignacion de informacion a hidden field del modal
   * - Validacion y ejecución del formulario
   */
  // Al hacer click en eliminar un cliente
  $("#kt_datatable_client_plans").on("click", ".delete-button", function(e){
    $('#delete_client_plan_modal').modal('toggle')
    // Obtiene el id del cliente
    var clientPlanId = $(this).attr("data-id")
    // Asigna el id del cliente en el campo hidden del modal
    $("#delete_client_plan_modal #hidden_modal_id").val(clientPlanId)
    // Se asigna la url correspondiente
    var url = `/admin/clientes/activaciones/${clientPlanId}/destroy`;
    $("#form_modal_delete_client_plan").attr("action", url)
    // Si el cliente se debe archivar porque tiene ofertas
    // Modifica la descripcion del modal
    $("#delete_client_plan_modal .modal-body .description").text("Esta acción no se puede revertir.")
    // Modifica el texto del boton
    $("#delete_client_plan_modal .modal-footer #send_modal_delete_client_plan_form").text("Eliminar")
    // Quita la clase not-delete para que al enviar el formulario muestre el texto de "Eliminando..."
    $("#delete_client_plan_modal .modal-footer #send_modal_delete_client_plan_form").removeClass("not-delete")
  })

  // Al cerrar el modal limpia la url y el hidden
  $("#delete_client_plan_modal .close").on("click", function(e){
    cleanClientModalFields()
  })

  // Al hacer click en confirmar eliminacion del cliente
  $("#delete_client_plan_modal #cancel_modal_delete_client_form").on("click", function(e){
    cleanClientModalFields()
  })

  // Al hacer click en enviar cliente
  $("#delete_client_plan_modal #send_modal_delete_client_plan_form").on("click", function(e){
    // Valida que el campo hidden tenga información
    var clientId = $("#delete_client_plan_modal #hidden_modal_id").val()
    // Si tiene informacion ejecuta el formulario
    if(clientId.length > 0) {
      // Se desabilitan las acciones
      // Si se esta archivando un cliente
      if($(this).hasClass("not-delete")){
          // Cambia el texto del boton a Archivando
          $(this).addClass("disabled").text("Archivando...")
      // De lo contrario esta eliminando el cliente
      } else {
          // Cambia el texto del boton a Eliminando
          $(this).addClass("disabled").text("Eliminando...")
      }
      $("#delete_client_plan_modal #cancel_modal_delete_client_form").addClass("disabled")
      $("#delete_client_plan_modal #close_delete_client_plan_modal").addClass("disabled")
      $("#form_modal_delete_client_plan").submit()
    } else {
      // Si no se puede eliminar
      $(".modal-body").find(".error-modal").remove()
      $(".modal-body").prepend('<div class="error-modal"><i class="fas fa-times-circle"></i><p>Hubo un problema y no se pudo eliminar la activación. Por favor intente más tarde.</p></div>')
    }
  })

  // Limpia el campo hidden y la url del form
  function cleanClientModalFields(){
    // Limpia si hay errores
    $(".modal-body").find(".error-modal").remove()
    // Limpia el campo hidden
    $("#delete_client_plan_modal #hidden_modal_id").val(null)
    // Se limpia la url correspondiente
    var url = '';
    $("#form_modal_delete_client_plan").attr("action", url)
  }
  /*************
   * FIN ELIMINAR ACTIVACIÓN
   */
});